/**
 * Verifica se o dispositivo possui uma câmera (webcam).
 * @returns {Promise<boolean>} Retorna uma promessa que resolve para `true` se uma câmera for encontrada, e `false` caso contrário.
 */
export const checkForCamera = async () => {
  if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    console.warn("A API MediaDevices não é suportada neste navegador.");
    return false;
  }

  try {
    // Pede permissão para acessar a câmera.
    await navigator.mediaDevices.getUserMedia({ video: true });

    const devices = await navigator.mediaDevices.enumerateDevices();
    const hasVideoInput = devices.some(device => device.kind === 'videoinput');
    
    // Libera a câmera após a verificação
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    stream.getTracks().forEach(track => track.stop());

    return hasVideoInput;
  } catch (error) {
    console.error("Erro ao verificar a câmera: ", error);
    return false;
  }
};
